module.exports = __webpack_public_path__ + "static/femi-shonubi-18bf08444d5452a990ae1943d50e5e1f.jpg";